import $ from 'jquery'
import Cookies from 'js-cookie'

// We need jQuery for Analytics
window.$ = $
window.jQuery = $

// Old tags are looking for $.cookie
window.$.cookie = Cookies
